import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import countryList from 'react-select-country-list';
import styled from 'styled-components';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import Tooltip from '@material-ui/core/Tooltip';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Input from '@material-ui/core/Input';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';

// eslint-disable-next-line react/prefer-stateless-function
class CustomSelect extends React.Component {
  render() {
    const {
      isValid,
    } = this.props;

    const customStyles = {
      control: (base, state) => ({
        ...base,
        // state.isFocused can display different borderColor if you need it
        borderColor: state.isFocused
          ? '#ddd' : isValid
            ? '#ddd' : 'red',
        // overwrittes hover style
        '&:hover': {
          borderColor: state.isFocused
            ? '#ddd' : isValid
              ? '#ddd' : 'red',
        },
      }),
    };
    return <Select styles={customStyles} {...this.props} />;
  }
}

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin: 15px;
  margin-right: 0px;
  margin-top: 0px;
  min-height: 45px;
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    margin-right: 15px;
    margin-top: 15px;
  }
`;
export const Tile = styled.div`
  cursor: pointer;
  border-radius: 5px;
  padding: 5px;
  &:hover {
    background-color: #ccc;
  }
  &:active {
    border: 1px solid #000;
  }
`;
export const FloatRight = styled.div`
  text-align: right;
`;
const SelectGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-bottom: 20px;
`;
const IndentLabel = styled.label`
  margin-left: 30%;
  text-align: right;
  margin-top: 25px;
  margin-right: 25px;
`;
const IndentContainer = styled.div`
  // margin-left: 50%;
`;
const IndentDiv = styled.div`
  margin-left: 20%;
`;
const IndentField = withStyles({
  root: {
    width: '80%',
    marginLeft: '20%',
    height: '40px',
    marginTop: 0,
    marginBottom: 0,
    borderRadius: 0,
  },
})(TextField);
const ToolTipStyled = withStyles({
  tooltip: {
    fontSize: '15px',
  },
})(Tooltip);
const InfoOutlinedIconStyled = withStyles({
  root: {
    position: 'absolute',
    paddingLeft: '2px;',
  },
})(InfoOutlinedIcon);
const SmallTextField = withStyles({
  root: {
    borderRadius: 0,
    maxHeight: '40px',
  },
})(TextField);
const StyledLabel = styled.label`
  margin-top: 10px;
  text-align: right;
  margin-right: 25px;
  font-family: roboto;
`;
const RightLabel = styled.label`
  text-align: right;
  margin-right: 25px;
  margin-top: 8px;
`;

export const TileContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
`;

export const Title = (props) => {
  const { error, value, handleChange } = props;
  const [errorSwitch, setErrorSwitch] = useState(error);
  useEffect(() => {
    setErrorSwitch(error);
  }, [error]);
  return (
    <>
      <StyledLabel>
        Enter project title
        {' '}
        <ToolTipStyled title="Please specify the name of the project.">
          <InfoOutlinedIconStyled fontSize="small" />
        </ToolTipStyled>
      </StyledLabel>
      <SmallTextField
        id="outlined-name"
        margin="none"
        variant="outlined"
        multiline
        error={errorSwitch}
        rowsMax="2"
        onChange={(e) => {
          handleChange(e, 'title');
          setErrorSwitch(false);
        }
        }
        value={value}
      />
    </>
  );
};



export const CompositionNumber = (props) => {
  let title = 'Please specify the number of target audiences you would like to participate in this test.';
  if (props.type === 'Brand health checks') {
    title = 'Please specify the number of target audiences you would like to participate in the check.';
  }
  return (
    <>
      <StyledLabel>
        Number of target audiences
        {' '}
        <ToolTipStyled title={title}>
          <InfoOutlinedIconStyled fontSize="small" />
        </ToolTipStyled>
      </StyledLabel>
      <SmallTextField
        id="outlined-name"
        margin="none"
        variant="outlined"
        max="5"
        type="number"
        value={props.value > 5 ? 5 : props.value < 1 ? 1 : props.value}
        inputProps={{ min: '1', max: '5', step: '1' }}
        onChange={e => (parseInt(e.target.value) > 0 && parseInt(e.target.value) < 6
          ? props.handleChange(e, 'compNumber')
          : '')
        }
      />
    </>
  );
};

export const Composition = (props) => {
  const { filledInError, value, handleChange } = props;
  const options = [
    { value: 1, label: 'MF 18-65' },
    {
      value: 0,
      label: 'Other',
    },
  ];
  const title = 'Please specify your target audience. Male and female between the ages of 18 and 65 is standard. Please use the option ‘other’ to fill in the boxes to specify a different target audience.';
  const [errorSwitch, setErrorSwitch] = useState(filledInError.composition);
  useEffect(() => {
    setErrorSwitch(filledInError.composition);
  }, [filledInError.composition]);
  return (
    <>
      <RightLabel>
        Composition
        {' '}
        <ToolTipStyled title={title}>
          <InfoOutlinedIconStyled fontSize="small" />
        </ToolTipStyled>
      </RightLabel>
      {' '}
      <CustomSelect
        isValid={!errorSwitch}
        options={options}
        value={props.value}
        onChange={e => {props.handleChange(e, 'composition', props.index); setErrorSwitch(false);}}
      />
      {props.value && props.value.value === 0 ? props.children : null}
    </>
  );
};

export const SampleSize = (props) => {
  if (props.type === 'Campaign evaluations') {
    return (
      <>
        <StyledLabel style={{ marginBottom: '20px' }}>
          Sample size Pre-measurement
          {' '}
          <ToolTipStyled title="Please specify the number of respondents you would like to participate in the evaluation before the measurement. We use a minimum of 200 respondents to obtain credible results.">
            <InfoOutlinedIconStyled fontSize="small" />
          </ToolTipStyled>
        </StyledLabel>
        <SmallTextField
          id="outlined-test"
          margin="none"
          variant="outlined"
          type="number"
          value={props.value[0]}
          inputProps={{ min: '200', step: '1' }}
          onChange={e => props.handleChange(e, 'sampleSize', 0)}
        />
        <StyledLabel>
          Sample size Post-measurement
          <ToolTipStyled title="Please specify the number of respondents you would like to participate in the test. We use a minimum of 200 respondents per measurement to obtain credible results.">
            <InfoOutlinedIconStyled fontSize="small" />
          </ToolTipStyled>
        </StyledLabel>
        <SmallTextField
          id="outlined-name"
          margin="none"
          variant="outlined"
          type="number"
          value={props.value[1]}
          inputProps={{ min: '200', step: '1' }}
          onChange={e => props.handleChange(e, 'sampleSize', 1)}
        />
      </>
    );
  }
  const min = props.type === 'Brand health checks' ? 400 : 150;
  const title = props.type === 'Brand health checks'
    ? 'Please specify the number of respondents you would like to participate in the test. We use a minimum of 400 respondents to obtain credible results.'
    : 'Please specify the number of respondents you would like to participate in the test. We use a minimum of 150 respondents to obtain credible results.';
  const value = props.type === 'Brand health checks' && props.value < 400
    ? '400'
    : props.value[0];
  return (
    <>
      <StyledLabel>
        Sample size
        <ToolTipStyled title={title}>
          <InfoOutlinedIconStyled fontSize="small" />
        </ToolTipStyled>
      </StyledLabel>
      <SmallTextField
        id="outlined-name"
        margin="none"
        variant="outlined"
        type="number"
        value={value}
        inputProps={{ min, step: '1' }}
        onChange={e => (parseInt(e.target.value) > 1
          ? props.handleChange(e, 'sampleSize', 0)
          : '')
        }
      />
    </>
  );
};

export const AdNumber = (props) => {
  let title = 'Please specify the number of ads you would like to test.';
  if (props.type === 'animatics') {
    title = 'Please specify the number of animatics you would like to test.';
  } else if (props.type === 'product concepts') {
    title = 'Please specify the number of product concepts you would like to test.';
  } else if (props.type === 'pack designs') {
    title = 'Please specify the number of pack designs you would like to test.';
  } else if (props.type === 'Logo tests') {
    title = 'Please specify the number of logos you would like to test.';
  } else if (props.type === 'claims') {
    title = 'Please specify the number of claims you would like to test.';
  } else if (props.type === 'POS materials') {
    title = 'Please specify the number of materials you would like to test.';
  }
  return (
    <>
      <StyledLabel>
        Number of
        {' '}
        {props.type}
        <ToolTipStyled title={title}>
          <InfoOutlinedIconStyled fontSize="small" />
        </ToolTipStyled>
        {props.type === 'claims' && props.value > 15 ? (
          <p style={{ color: 'red' }}>You cannot test more than 15 claims!</p>
        ) : null}
      </StyledLabel>
      {props.type === 'claims' ? (
        <SmallTextField
          id="outlined-name"
          margin="none"
          variant="outlined"
          type="number"
          value={
            props.value <= 15 && props.value > 0
              ? props.value
              : ''
          }
          onChange={e => (parseInt(e.target.value) > 0 ? props.handleChange(e, 'adNumber') : '')
          }
        />
      ) : (
        <SmallTextField
            id="outlined-name"
            margin="none"
            variant="outlined"
            type="number"
            value={props.value}
            onChange={e => (parseInt(e.target.value) > 0 ? props.handleChange(e, 'adNumber') : '')
            }
          />
      )}
    </>
  );
};

export const CurrentDesign = (props) => {
  const options = [{ value: 0, label: 'No' }, { value: 1, label: 'Yes' }];
  const title = 'Please specify whether you would like to include the current design in the test.';
  return (
    <>
      <RightLabel>
        Include current design
        {' '}
        <ToolTipStyled title={title}>
          <InfoOutlinedIconStyled fontSize="small" />
        </ToolTipStyled>
      </RightLabel>
      <Select
        options={options}
        value={props.value}
        onChange={e => props.handleChange(e, 'currentDesign')}
      />
    </>
  );
};

export const Country = (props) => {
  const countries = countryList().getData();
  const title = 'Please select the country or countries in which the test should be conducted.';
  return (
    <>
      <RightLabel>
        Select countries
        <ToolTipStyled title={title}>
          <InfoOutlinedIconStyled fontSize="small" />
        </ToolTipStyled>
      </RightLabel>
      <Select
        options={countries}
        isMulti
        value={props.value}
        onChange={e => props.handleChange(e, 'countries')}
      />
    </>
  );
};


export const NumberClosedQuestions = (props) => {
  const options = [
    {
      value: 0,
      label: '0-10',
    },
    { value: 1, label: '11-20' },
    { value: 2, label: '20+' },
  ];
  const title = 'Please specify how many closed questions you would like to include.';
  return (
    <>
      <RightLabel>
        Number of Closed Questions
        {' '}
        <ToolTipStyled title={title}>
          <InfoOutlinedIconStyled fontSize="small" />
        </ToolTipStyled>
      </RightLabel>
      <Select
        options={options}
        value={props.value}
        onChange={e => props.handleChange(e, 'numberClosedQuestions', props.index)}
      />
      {props.value && props.value.value === 0 ? props.children : null}
    </>
  );
};

const NumberOpenQuestions = (props) => {
  const title = 'Please fill in the number of open questions you would like to add to the project';
  return (
    <>
      <RightLabel>
        Number of Open Questions
        {' '}
        <ToolTipStyled title={title}>
          <InfoOutlinedIconStyled fontSize="small" />
        </ToolTipStyled>
      </RightLabel>
      <SmallTextField
        id="outlined-name"
        margin="none"
        variant="outlined"
        type="number"
        defaultValue={0}
        onChange={e => (parseInt(e.target.value) > 0 ? props.handleChange(e, 'numberOpenQuestions') : '')
        }
      />
      <br />
    </>
  );
};

// export const AdNumber = (props) => {
//   return (
//     <>
//       <StyledLabel>
//         Number of
//         {' '}
//         {props.type}
//         <ToolTipStyled title={title}>
//           <InfoOutlinedIconStyled fontSize="small" />
//         </ToolTipStyled>
//         {props.type === 'claims' && props.value > 15 ? (
//           <p style={{ color: 'red' }}>You cannot test more than 15 claims!</p>
//         ) : null}
//       </StyledLabel>
//       {props.type === 'claims' ? (
//         <SmallTextField
//           id="outlined-name"
//           margin="none"
//           variant="outlined"
//           type="number"
//           value={
//           props.value <= 15 && props.value > 0
//             ? props.value
//             : ''
//         }
//           onChange={e => (parseInt(e.target.value) > 0 ? props.handleChange(e, 'adNumber') : '')
//         }
//         />
//       ) : (
//         <SmallTextField
//           id="outlined-name"
//           margin="none"
//           variant="outlined"
//           type="number"
//           value={props.value}
//           onChange={e => (parseInt(e.target.value) > 0 ? props.handleChange(e, 'adNumber') : '')
//         }
//         />
//       )}
//     </>
//   );
// };

export const MediaType = (props) => {
  const options = [
    { value: 1, label: 'Radio' },
    {
      value: 0,
      label: 'TV',
    },
  ];
  const title = 'Please select the media type of your Tag-on(s)';
  return (
    <>
      <RightLabel>
        Media type
        {' '}
        <ToolTipStyled title={title}>
          <InfoOutlinedIconStyled fontSize="small" />
        </ToolTipStyled>
      </RightLabel>
      <Select
        options={options}
        value={props.value}
        onChange={e => props.handleChange(e, 'mediaType', props.index)}
      />
      {props.value && props.value.value === 0 ? props.children : null}
    </>
  );
};

export const TargetDescription = (props) => {
  const title = 'Please specify your target audience based on gender, age and/or additional characteristics.';
  return (
    <>
      <IndentLabel>
        Target description
        {' '}
        <ToolTipStyled title={title}>
          <InfoOutlinedIconStyled fontSize="small" />
        </ToolTipStyled>
      </IndentLabel>
      <IndentField
        style={{ marginTop: '15px', marginRight: '25px' }}
        id="outlined-name"
        margin="none"
        variant="outlined"
        value={props.value.targetDescription || ''}
        onChange={e => props.handleChange(e, 'targetDescription', props.index)
        }
      />
    </>
  );
};
export const EstimatedIr = (props) => {
  const title = 'Please specify the rate of occurrence or the percentage of persons eligible to participate in the test.';
  return (
    <>
      <IndentLabel style={{ marginRight: '25px' }}>
        Estimated IR
        {' '}
        <ToolTipStyled title={title}>
          <InfoOutlinedIconStyled fontSize="small" />
        </ToolTipStyled>
        {props.value.estimatedIr > 100 ? (
          <p style={{ color: 'red' }}>Please give a value between 0 and 100!</p>
        ) : null}
      </IndentLabel>
      <IndentField
        style={{ paddingTop: '15px' }}
        id="outlined-name"
        margin="none"
        value={
          props.value.estimatedIr <= 100 && props.value.estimatedIr > 0
            ? props.value.estimatedIr
            : ''
        }
        variant="outlined"
        onChange={e => props.handleChange(e, 'estimatedIr', props.index)}
      />
    </>
  );
};

export const CampaignStatements = (props) => {
  const title = 'Please specify the number of campaign message statements you would like to include in this test';
  return (
    <>
      <StyledLabel style={{ marginTop: 0 }}>
        Campaign message statements:
        {' '}
        <ToolTipStyled title={title}>
          <InfoOutlinedIconStyled fontSize="small" />
        </ToolTipStyled>
      </StyledLabel>
      <SmallTextField
        id="outlined-name"
        margin="none"
        type="number"
        variant="outlined"
        value={props.value}
        onChange={e => props.handleChange(e, 'campaignStatements')}
      />
    </>
  );
};
export const StartDate = (props) => {
  const title = 'Please specify the date the campaign starts.';
  return (
    <>
      <IndentLabel>
        Start date:
        {' '}
        <ToolTipStyled title={title}>
          <InfoOutlinedIconStyled fontSize="small" />
        </ToolTipStyled>
      </IndentLabel>
      <IndentField
        style={{ marginTop: '15px', marginRight: '25px' }}
        id="outlined-name"
        margin="none"
        type="date"
        variant="outlined"
        value={props.value}
        onChange={e => props.handleChange(e, 'startDate')}
      />
    </>
  );
};
export const EndDate = (props) => {
  const title = 'Please specify the date the campaign ends.';

  return (
    <>
      <IndentLabel>
        End date:
        {' '}
        <ToolTipStyled title={title}>
          <InfoOutlinedIconStyled fontSize="small" />
        </ToolTipStyled>
      </IndentLabel>
      <IndentField
        style={{ marginTop: '15px', marginRight: '25px' }}
        id="outlined-name"
        margin="none"
        type="date"
        variant="outlined"
        value={props.value}
        onChange={e => props.handleChange(e, 'endDate')}
      />
    </>
  );
};

export const DeadLine = (props) => {
  const title = 'Please specify when the project needs to be finished.';
  return (
    <>
      <RightLabel>
        Deadline:
        {/* {' '} */}
        <ToolTipStyled title={title}>
          <InfoOutlinedIconStyled fontSize="small" />
        </ToolTipStyled>
      </RightLabel>
      <TextField
        // style={{ marginTop: '15px', marginRight: '25px' }}
        id="outlined-name"
        margin="none"
        type="date"
        variant="outlined"
        value={props.value}
        onChange={e => props.handleChange(e, 'deadLine')}
      />
    </>
  );
};

export const CampaignCreatives = (props) => {
  const options = [
    { value: 0, label: '0' },
    { value: 1, label: '1' },
    { value: 2, label: '2' },
    { value: 3, label: '3' },
  ];
  const title = 'Please specify the creatives and the number of creatives you want to include in the campaign evaluation.';
  return (
    <>
      <StyledLabel style={{ marginTop: 0 }}>
        Campaign creatives to be included:
        {' '}
        <ToolTipStyled title={title}>
          <InfoOutlinedIconStyled fontSize="small" />
        </ToolTipStyled>
      </StyledLabel>

      <IndentDiv>
        <SelectGrid>
          TV
          <Select
            options={options}
            value={props.value[0]}
            onChange={e => props.handleChange(e, 'campaignCreatives', 0)}
          />
        </SelectGrid>
        <SelectGrid>
          OOH
          <Select
            options={options}
            value={props.value[1]}
            onChange={e => props.handleChange(e, 'campaignCreatives', 1)}
          />
          {' '}
        </SelectGrid>
        <SelectGrid>
          Digital
          <Select
            options={options}
            value={props.value[2]}
            onChange={e => props.handleChange(e, 'campaignCreatives', 2)}
          />
          {' '}
        </SelectGrid>
        <SelectGrid>
          Print
          <Select
            options={options}
            value={props.value[3]}
            onChange={e => props.handleChange(e, 'campaignCreatives', 3)}
          />
          {' '}
        </SelectGrid>
        <SelectGrid>
          Radio
          <Select
            options={options}
            value={props.value[4]}
            onChange={e => props.handleChange(e, 'campaignCreatives', 4)}
          />
          {' '}
        </SelectGrid>
      </IndentDiv>
    </>
  );
};

export const ExtraQuestions = (props) => {
  const title = 'Please specify whether you would like to add additional questions to the test. You can add up to 5 questions.';
  return (
    <>
      <RightLabel style={{ marginTop: '13px' }}>
        Additional questions:
        <ToolTipStyled title={title}>
          <InfoOutlinedIconStyled fontSize="small" />
        </ToolTipStyled>
      </RightLabel>
      <div>
        <IndentContainer>
          <label>Yes</label>
          <Radio
            checked={props.value === '1'}
            onChange={e => props.handleChange(e, 'extraQuestions')}
            value="1"
            color="primary"
            name="radio-button-demo"
            aria-label="Yes"
            label="Yes"
          />
          <label>No</label>
          <Radio
            checked={props.value === '0'}
            onChange={e => props.handleChange(e, 'extraQuestions')}
            value="0"
            color="primary"
            name="radio-button-demo"
            aria-label="No"
            label="No"
          />
        </IndentContainer>
      </div>
    </>
  );
};

export const ExtraOpenQuestions = (props) => {
  const title = 'Please specify whether you would like to add additional open questions to the project.';
  const [boolean, setBoolean] = useState(false);
  return (
    <>
      <RightLabel style={{ marginTop: '13px' }}>
        Additional open questions:
        <ToolTipStyled title={title}>
          <InfoOutlinedIconStyled fontSize="small" />
        </ToolTipStyled>
      </RightLabel>
      <div>
        <IndentContainer>
          <label>Yes</label>
          <Radio
            checked={boolean}
            onChange={(e) => { setBoolean(!boolean); props.handleChange(true, 'extraOpenQuestions'); }}
            color="primary"
            name="radio-button-demo"
            aria-label="Yes"
            label="Yes"
          />
          <label>No</label>
          <Radio
            checked={!boolean}
            onChange={(e) => { setBoolean(!boolean); props.handleChange(false, 'extraOpenQuestions'); }}
            color="primary"
            name="radio-button-demo"
            aria-label="No"
            label="No"
          />
        </IndentContainer>
      </div>
      {boolean ? (
        <NumberOpenQuestions {...props} />
      ) : null}
    </>
  );
};

export const UploadQuestionnaire = (props) => {
  const { handleSelectedFile } = props;
  const title = 'If you already have a questionnaire ready, you can upload it here.';
  return (
    <>
      <RightLabel style={{ marginTop: '13px' }}>
        Upload questionnaire:
        <ToolTipStyled title={title}>
          <InfoOutlinedIconStyled fontSize="small" />
        </ToolTipStyled>
      </RightLabel>
      <div>
        <IndentContainer>
          <Input
            type="file"
            name="questionnaire"
            onChange={handleSelectedFile}
          />
        </IndentContainer>
      </div>
    </>
  );
};

export const Reporting = (props) => {
  const title = 'Please specify how you would like to receive the results. You can tick all the relevant boxes.';
  return (
    <>
      <RightLabel style={{ marginTop: '13px' }}>
        Reporting:
        <ToolTipStyled title={title}>
          <InfoOutlinedIconStyled fontSize="small" />
        </ToolTipStyled>
      </RightLabel>
      <div>
        <IndentContainer>
          <FormGroup>
            <FormControlLabel
              control={(
                <Checkbox
                  onChange={(e) => {
                    props.handleChange(e.target.checked, 'tableBook');
                  }
                  }
                />
              )}
              label="Table Book"
            />
            <FormControlLabel
              control={(
                <Checkbox
                  onChange={(e) => {
                    props.handleChange(e.target.checked, 'spssFile');
                  }
                  }
                />
              )}
              label="SPSS File"
            />
            <FormControlLabel
              control={(
                <Checkbox
                  onChange={(e) => {
                    props.handleChange(e.target.checked, 'excelFile');
                  }
                  }
                />
              )}
              label="Excel File"
            />
            <FormControlLabel
              control={(
                <Checkbox
                  onChange={(e) => {
                    props.handleChange(e.target.checked, 'powerpointReport');
                  }
                  }
                />
              )}
              label="Powerpoint Report"
            />
            <FormControlLabel
              control={(
                <Checkbox
                  onChange={(e) => {
                    props.handleChange(e.target.checked, 'presentation');
                  }
                  }
                />
              )}
              label="Presentation"
            />
          </FormGroup>
        </IndentContainer>
      </div>
    </>
  );
};

export const Objective = (props) => {
  const { error, value, handleChange } = props;
  let title = 'Please specify your project’s objective: what you expect to achieve with this test.';
  if (props.type === 'Campaign evaluations') {
    title = 'Please specify your project’s objective: what you expect to achieve with this campaign evaluation.';
  }
  const [errorSwitch, setErrorSwitch] = useState(error);
  useEffect(() => {
    setErrorSwitch(error);
  }, [error]);
  return (
    <>
      <StyledLabel>
        Objective
        {' '}
        <ToolTipStyled title={title}>
          <InfoOutlinedIconStyled fontSize="small" />
        </ToolTipStyled>
      </StyledLabel>
      <SmallTextField
        id="outlined-name"
        margin="none"
        variant="outlined"
        multiline
        rowsMax="2"
        value={value}
        error={errorSwitch}
        onChange={(e) => {
          handleChange(e, 'objective');
          setErrorSwitch(false);
        }
        }
      />
    </>
  );
};
